/**
 * Colours for the stage ladder.
 *
 * A stage is a description of where a business is, not a grade. Build is the
 * beginning of the journey, not a failure — so the ramp deliberately avoids
 * red/amber/green, which would read as danger → warning → success and tell an
 * owner their company is "failing" when it is simply early.
 *
 * Instead the scale is a single cool progression that deepens with stage:
 * further along reads as more saturated and darker. That carries direction
 * without judgement, and because the signal is mostly lightness it survives
 * colour-blindness and greyscale printing.
 *
 * Every colour clears 4.5:1 against white text, in either theme — these are
 * the one place in the feature that opts out of the neutral palette, because
 * the ladder position is the result itself rather than a status decoration.
 */
export const STAGE_RAMP: readonly string[] = [
  "#64748B", // slate-500  — earliest stage, neutral
  "#4F7A8B", // deeper teal-slate
  "#3A2C6A", // secondary-light (brand)
  "#17084A", // secondary (brand navy) — furthest along
];

/** Shown when no stage has been placed yet. */
export const STAGE_UNPLACED = "#6B7280";

/**
 * Colour for a stage index, falling back sensibly for diagnostics with more
 * bands than the ramp defines: the last colour repeats rather than throwing.
 */
export function stageColor(stage: number | null | undefined): string {
  if (stage == null) return STAGE_UNPLACED;
  if (stage < 0) return STAGE_UNPLACED;
  return STAGE_RAMP[Math.min(stage, STAGE_RAMP.length - 1)];
}
